import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import DivisionLevelDocs from "../components/divisionLevelDocs.js"
import Layout from "../components/layout"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFilePdf,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons"
import "../styles/global.css"
import { RichText } from "prismic-reactjs"

export const query = graphql`
  query DivisionPostings($slug: String) {
    prismic {
      allAll_employment_opportunitiess {
        edges {
          node {
            _meta {
              id
              type
            }
            body {
              ... on PRISMIC_All_employment_opportunitiesBodyDivision_listing {
                type
                label
                primary {
                  division
                  number_of_positions
                  upperdetails
                  supplementaldetails
                }
                fields {
                  division_level_document {
                    _linkType
                    ... on PRISMIC__FileLink {
                      _linkType
                      name
                      url
                    }
                    ... on PRISMIC__ImageLink {
                      _linkType
                      name
                      url
                    }
                    ... on PRISMIC__ExternalLink {
                      target
                      _linkType
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
      allEmployment_opportunitys(
        where: { division: $slug }
        sortBy: position_name_ASC
      ) {
        edges {
          node {
            _meta {
              id
              type
            }
            additional_details
            location
            close_date
            close_text_override
            division
            post_date
            position_name
            salary
            posting {
              ... on PRISMIC__FileLink {
                _linkType
                name
                url
              }
            }
          }
        }
      }
    }
  }
`
const CloseDate = ({ node }) => {
  if (node.node.close_date != null) {
    return (
      <td classNam="table-column-width-small" data-th="Closes On">
        {new Date(
          Date.parse(new Date(node.node.close_date).toISOString())
        ).toLocaleDateString()}
      </td>
    )
  } else if (node.node.division === "Assembly") {
    return (
      <td className="table-column-width-med" data-th="Closes On">
        Applications will be accepted until recruitment needs are satisfied
      </td>
    )
  } else if (node.node.close_text_override != null) {
    return (
      <td className="table-column-width-med" data-th="Closes On">
        APPLICATIONS WILL BE ACCEPTED UNTIL THE POSITION IS FILLED.
        <RichText render={node.node.close_text_override[0].text} />
      </td>
    )
  } else {
    return (
      <td className="table-column-width-med" data-th="Closes On">
        APPLICATIONS WILL BE ACCEPTED UNTIL THE POSITION IS FILLED. (All
        applications will be accepted on a first-come, first-served basis.
        Hiring may occur at any time during the recruitment process.)
      </td>
    )
  }
}

const PostingRow = ({ node }) => {
  var currentDate = new Date()
  var thisDate = new Date(node.node.close_date).toISOString()
  var closeDate = Date.parse(thisDate)
  if (
    new Date(closeDate).getTime() >= new Date(currentDate.toJSON()).getTime() ||
    node.node.close_date === null
  ) {
    return (
      <tr>
        {node.node.posting != null ? (
          <td className="table-column-width-nowrap" data-th="Posting">
            <a
              href={node.node.posting.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFilePdf} className="mr-2 text-danger" />
              {node.node.position_name}
            </a>
          </td>
        ) : (
          <td className="table-column-width" data-th="Posting">
            {node.node.position_name}
          </td>
        )}
        <td className="table-column-width-small" data-th="Location">
          {node.node.location}
        </td>
        <td className="table-column-width-small" data-th="Posted On">
          {new Date(
            Date.parse(new Date(node.node.post_date).toISOString())
          ).toLocaleDateString()}
        </td>
        <CloseDate node={node} />
        {node.node.salary != null ? (
          <td className="table-column-width-med" data-th="Salary">
            {node.node.salary[0].text}
          </td>
        ) : (
          <td data-th="Salary">TBD</td>
        )}

        {node.node.additional_details != null ? (
          <td data-th="Addition Details">
            {node.node.additional_details[0].text}
          </td>
        ) : (
          <td data-th="Addition Details"></td>
        )}
      </tr>
    )
  } else {
    return null
  }
}

const Posting = props => {
  const doc = props.data.prismic.allEmployment_opportunitys
  const divDoc =
    props.data.prismic.allAll_employment_opportunitiess.edges[0].node.body
  const { pageContext } = props
  const { slug } = pageContext
  const { supDetails } = pageContext
  const { upperDetails } = pageContext
  let opps = { listings: divDoc, division: slug }

  const headerText = () => {
    return "Employment Opportunities"
  }

  const headerSubText = () => {
    return slug
  }

  const supplementalDetails = () => {
    if (supDetails !== undefined) {
      return RichText.render(supDetails)
    } else {
      return ""
    }
  }

  const upperpageDetails = () => {
    if (supDetails !== undefined) {
      return RichText.render(upperDetails)
    } else {
      return ""
    }
  }

  if (!doc) return null

  return (
    <Layout pageTitle={headerSubText()}>
      <div className="row mt-3 mb-2">
        <div className="col">
          <Link to="/">
            <FontAwesomeIcon icon={faLongArrowAltLeft} className="mr-2" />
            All Employment Opportunities
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <h1 className="text-center">
            {headerText()} - {headerSubText()}
          </h1>
        </div>
      </div>
      <div className="row">
        <div className="col align-self-center m-auto">{upperpageDetails()}</div>
      </div>
      <div className="row mt-2">
        <div className="col">
          <div className="table-responsive">
            <table className="table bg-white">
              <thead className="border-top-accent-cool">
                <tr>
                  <th className="table-column-width-nowrap">Position</th>
                  <th className="table-column-width-small">Location</th>
                  <th className="table-column-width-small">Posted On</th>
                  <th>Closes On</th>
                  <th>Salary</th>
                  <th>Additional Details</th>
                </tr>
              </thead>
              <tbody>
                {doc.edges.map(node => (
                  <PostingRow node={node} key={node.node._meta.id} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 m-auto">
          <p>{supplementalDetails()}</p>
        </div>
      </div>
      <div className="row mt-lg-5">
        <div className="col-md-8 m-auto">
          <DivisionLevelDocs props={opps} />
        </div>
      </div>
    </Layout>
  )
}

export default Posting
